<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent" v-if="component"></column-header>
    <div>
      <div class="row">
        <div class="col-md-9">
          <h3>{{ content.name }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <component v-if="editorComponent" :is="editorComponent" :version="version" v-model="content" v-on:componentReady="componentReady" />
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from 'axios'
import changewatcher from '~/lib/changewatcher'
import components from '~/lib/components'

export default {
  data () {
    return {
      content: {},
      componentLoaded: false
    }
  },
  mixins: [changewatcher, components],
  computed: {
    editorComponent() {
      if (!this.content || !this.content.type) {
        return false
      }
      switch (this.content.type) {
        case 'Search2':
          return 'Search2Details'
        case 'RichText':
          return 'RichTextDetails'
        default:
          return 'CommonDetails'
      }
      return false
    },
    editorConfig () {
      return {
        toolbar:
          [
            ['Format', 'Bold', 'Italic', '-', 'NumberedList', 'BulletedList', 'Outdent', 'Indent', '-', 'Link', 'Unlink'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['Undo', 'Redo'],
            ['Source'],
            ['UIColor']
          ],
        height: '200px',
        language: this.shortLocale,
        allowedContent: true,
        extraPlugins: 'justify'
      }
    }
  },
  watch: {
    content () {
      console.log("Content change")
      console.log(this.content)
    },
    componentLoaded (newValue) {
      if (newValue) {
        this.storeState()
      }
    }
  },
  methods: {
    componentReady () {
      this.componentLoaded = true
    },
    async reloadOnVersionChange () {
      if (!this.content || !this.content.id) {
        return
      }
      await this.loadContent(this.content.id)
    },
    loadContent (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/cmscontent/' + id + '.json?full=true&apikey=' + this.apiKey + this.versionStr)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.content = response.data
        // Note: this is done in the watcher so that we wait for the editor to be ready
        // this.storeState()
        this.loading = false
        resolve(this.content)
      })
    },
    getSaveData () {
      let { _id, created, revision, updated, type, ...data } = this.content
      return data
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      data.version = this.version
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/cmscontent/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/cmscontent.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadContent(response.data.id)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.customer)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    setParams (params) {
      this.content = params
    }
  },
  components: {
    CommonDetails: () => import('~/components/content/CommonDetails'),
    RichTextDetails: () => import('~/components/content/RichTextDetails'),
    Search2Details: () => import('~/components/content/Search2Details')
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadContent(this.component.initData.contentId)
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.content && this.content.id && parseInt(this.content.id, 10) !== parseInt(this.component.initData.contentId, 10)) {
        try {
          await this.loadContent(this.component.initData.contentId)
        } catch(e) {}
      }
    }
  },
  async mounted () {
    // Not sure what this is for, copied from customerdetails
    if(!this.events) {
      let events = {}
      events['showContentDetailsParams'] = (message) => {
        this.setParams(message)
      }
      events['contentUpdate'] = async (message) => {
        if (message && message.data && this.content && parseInt(message.data.id, 10) === parseInt(this.content.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadContent(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>
